import React from 'react';
import ReactDOM from 'react-dom';
import Root from './app/components/Root';
import 'react-toastify/dist/ReactToastify.css';
import 'react-day-picker/lib/style.css';
import './index.scss';
import './i18n';
import './shared/styles/themeColors.scss';
import './httpCachingRequest';

// NOTE: some lazy-loaded chunks (eg. recharts' d3 dependencies, used by the dashboard) reference
// the bare `process` global at runtime, which the browser doesn't provide.
if (typeof window.process === 'undefined') {
    window.process = { env: { NODE_ENV: process.env.NODE_ENV } };
}

ReactDOM.render(<Root />, document.getElementById('root'));
